import { useEffect, useRef } from "react";

const MESSAGE = "You have unsaved changes. Are you sure you want to leave this page?";

export const useUnsavedChangesGuard = (isDirty, onLeave) => {
    const dirtyRef = useRef(isDirty);
    dirtyRef.current = isDirty;
    const onLeaveRef = useRef(onLeave);
    onLeaveRef.current = onLeave;

    useEffect(() => {
        window.history.pushState(null, "", window.location.href);

        const handlePopState = () => {
            if (!dirtyRef.current) {
                onLeaveRef.current?.();
                return;
            }
            if (window.confirm(MESSAGE)) {
                onLeaveRef.current?.();
            } else {
                window.history.pushState(null, "", window.location.href);
            }
        };
        window.addEventListener("popstate", handlePopState);

        const handleBeforeUnload = (e) => {
            if (!dirtyRef.current) return;
            e.preventDefault();
            e.returnValue = "";
        };
        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("popstate", handlePopState);
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
